module.exports = __webpack_public_path__ + "img/icon-mail.d2728e12.svg";